import { Component, inject, input } from '@angular/core';
import { UwIcon } from '../../ui/icon/uw-icon';
import { UwTooltip } from '../../directives/tooltip.directive';
import { EvidenceStore } from '../../../core/stores/evidence.store';

@Component({
  selector: 'uw-ai-trace-link',
  standalone: true,
  imports: [UwIcon, UwTooltip],
  template: `
    <button
      type="button"
      class="group inline-flex max-w-full items-center gap-1 rounded bg-surface-sunken px-1.5 py-0.5 align-baseline text-[12px] font-medium text-primary underline decoration-dotted underline-offset-2 transition-colors hover:bg-ai-soft hover:text-ai"
      (click)="open()"
      [attr.aria-label]="'Open source: ' + sourceName()"
      [uwTooltip]="sourceName() + ' · click to open source'"
    >
      <uw-icon name="file-search" [size]="11" class="shrink-0 text-ai" />
      <span class="truncate">{{ sourceName() }}</span>
    </button>
  `,
})
export class UwAiTraceLink {
  private readonly evidence = inject(EvidenceStore);

  readonly sourceId = input.required<string>();
  readonly sourceName = input<string>('source');

  protected open(): void {
    this.evidence.openSource(this.sourceId());
  }
}
